/* eslint-disable react-hooks/exhaustive-deps */
import { useLiveQuery } from "dexie-react-hooks";
import { useEffect, useMemo, useState } from "react";
import { db } from "~/db/db";
import useSelect from "~components/Form/hooks/useSelect";
import prepareForOptions from "~services/utils/prepareForOptions";

const useMotivoPerda = ({ formikRef, name = "motivoPerdaId" }) => {
  const motivoPerdaSelect = useSelect("motivoPerda");
  const [motivoPerda, setMotivoPerda] = useState(0);

  const [motivoPerdas, setMotivoPerdas] = useState([]);

  useEffect(() => {
    const fetchMotivoPerdas = async () => {
      const result = [];
      await db.motivosPerda.each((motivo) => result.push(motivo));
      setMotivoPerdas(result);
    };

    fetchMotivoPerdas();
  }, []);

  const optionMotivoPerdas = useMemo(() => prepareForOptions(motivoPerdas, ['nome'], 'id'), [motivoPerdas]);

  function onChangeMotivoPerda(e) {
    motivoPerdaSelect.upDateValue(e.value);
    motivoPerdaSelect.upDateDefaultValue(e || "");
    formikRef.current.setFieldValue(name, e.value);
    setTimeout(() => formikRef.current.setFieldTouched(name, true));
    setMotivoPerda(e.value);
  }

  function SetSelectMotivoPerda(id) {
    const motivoPerda = optionMotivoPerdas.find((o) => o.value === id);
    if (motivoPerda)
      onChangeMotivoPerda(motivoPerda);
  }

  const motivoSelecionado = useMemo(() => {
    if (motivoPerda && motivoPerda != 0)
      return motivoPerdas?.find(e => e.id == motivoPerda);
    return null;
  }, [motivoPerda])

  return {
    motivoSelecionado,
    motivoPerdas,
    optionMotivoPerdas,
    onChangeMotivoPerda,
    SetSelectMotivoPerda,
    motivoPerda,
    motivoPerdaSelect,
    setMotivoPerda
  };
}

export default useMotivoPerda;